import React from 'react'

import { string, arrayOf } from 'prop-types'

import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import InfoSvg from 'components/atoms/SVGIcons/Info'

import SectionTitleWithIcon from 'components/molecules/SectionTitleWithIcon'
import NumberedListItem from 'components/molecules/NumberedListItem'

import Relazsizes from 'relazsizes'

const CareerMustKnow = ({
  bannerDesktop,
  bannerDesktopAlt,
  bannerMobile,
  bannerMobileAlt,
  title,
  infos,
}) => (
  <div id="must-know" className="career-must-know">
    <SectionContainer paddingBottom={80}>
      <Container>
        <SectionTitleWithIcon
          icon={props => <InfoSvg fill="#0FC3C4" height="32px" width="32px" {...props}/>}
          title={title}
        />
        <Row>
          <Col md="5">
            <Relazsizes
              className="career-must-know__banner"
              el="picture"
              dataSrcset={[
                {
                  media: '(min-width: 768px)',
                  srcset: bannerDesktop,
                  alt: bannerDesktopAlt,
                },
              ]}
              dataSrc={bannerMobile}
              alt={bannerDesktopAlt || bannerMobileAlt}
            />
          </Col>
          <Col md="7">
            <div className="career-must-know__list">
              {
                infos.map((info, idx) => (
                  <NumberedListItem key={`career-must-know-${idx}`} no={idx + 1} content={info} bordered={false}/>
                ))
              }
            </div>
          </Col>
        </Row>
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .career-must-know {
          :global(&__banner) {
            width: 100%;
            border-radius: 8px;
            box-shadow: 0 8px 18px 0 rgba(0, 0, 0, 0.2);
          }
        }
      `}
    </style>
  </div>
)

CareerMustKnow.propTypes = {
  bannerDesktop: string,
  bannerDesktopAlt: string,
  bannerMobile: string,
  bannerMobileAlt: string,
  title: string,
  infos: arrayOf(string),
}

export default CareerMustKnow
